import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';
import { format } from 'date-fns';

import { FeApi, useInjectFeApiContext } from '@/api/fe-api';

import type { Site } from '../entities/site';
import type { Workstream } from '../entities/workstream';

export namespace AddWorkstreamMutation {
  export type Input = {
    siteId: Site['id'];
  } & (
    | {
        custom: Pick<
          Workstream,
          'name' | 'description' | 'startDate' | 'endDate'
        >;
      }
    | {
        template: { templateId: string } & Pick<
          Workstream,
          'startDate' | 'endDate'
        >;
      }
  );
  export type Output = void;

  function useMutationFn() {
    const addWorkstream = useInjectFeApiContext(
      FeApi.tasksV1WorkstreamsNewCreate,
    );

    return async function mutationFn(input: Input) {
      await ok(
        addWorkstream({
          createWorkstreamViewInputRequest:
            'custom' in input
              ? {
                  site_accure_id: input.siteId,
                  name: input.custom.name,
                  description: input.custom.description,
                  start_date: format(input.custom.startDate, 'yyyy-MM-dd'),
                  end_date: format(input.custom.endDate, 'yyyy-MM-dd'),
                }
              : {
                  site_accure_id: input.siteId,
                  name: input.template.templateId,
                  start_date: format(input.template.startDate, 'yyyy-MM-dd'),
                  end_date: format(input.template.endDate, 'yyyy-MM-dd'),
                  template_name: input.template.templateId,
                },
        }),
      );
    };
  }

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const mutationFn = useMutationFn();

    return rq.useMutation<Output, unknown, Input>({
      mutationFn,
      async onSuccess() {
        await queryClient.invalidateQueries({
          queryKey: ['project-management'],
        });
      },
    });
  }
}
